<template>

    <form @submit.prevent="SubmitForm()">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Share</p>
            </header>

            <section class="modal-card-body">

                <b-field label="Title">
                    <b-input
                        v-model="name"
                        placeholder="Enter title for share"
                        required
                        >
                    </b-input>
                </b-field>

                <b-field label="Project">
                    <b-autocomplete
                        required
                        v-model="project_autocomplete_name"
                        :data="filteredDataArray_Project"
                        placeholder="Pick a project!"
                        icon="magnify"
                    >
                        <template slot="empty">No results found</template>
                    </b-autocomplete>
                </b-field>

                <b-field label="Notes">
                    <b-input
                        v-model="notes"
                        maxlength="200"
                        type="textarea">
                    </b-input>
                </b-field>

                <b-field label="Reviewables"></b-field>
                <div
                    v-for="reviewable in reviewables"
                    v-bind:key="reviewable.id"
                >
                    <b-icon
                        icon="file-outline"
                        size="is-small">
                    </b-icon>

                    <span>{{ reviewable.name }}</span>
                </div>
            </section>

            <footer class="modal-card-body">
                <b-notification
                    auto-close 
                    type="is-success"
                    v-if="!createlink_show"
                    aria-close-label="Close notification">
                    Copied to clipboard
                </b-notification>
                <!-- v-show worked with setting focus -->
                <b-field
                    v-show="!createlink_show"
                    grouped
                >
                    <b-input
                        ref="input_url"
                        rounded
                        expanded
                        icon="link-variant"
                        type="text"
                        v-bind:value="share_url"
                        @focus="$event.target.select()"
                        readonly>
                    </b-input>
                </b-field>
                
                <b-field
                    v-if="createlink_show"
                >
                    <p class="control">
                        <button
                            class="button is-primary"
                            v-bind:class="{ 'is-loading' : create_share_loading }"
                        >
                            Create Link
                        </button>
                    </p>
                </b-field>
            </footer>
        </div>
    </form>
</template>

<script>
    import axios from 'axios'

    // get project objects (we want their IDs as well as names)
    import { GetProjects, GetProjectNames } from '../mixins/Projects'

    export default {
        mixins: [GetProjects, GetProjectNames],
        data() {
            return {
                isComponentModalActive: false,
                notes: '',
                name: '', // title
                user: '',
                project_autocomplete_name: '',
                project_autocomplete_selected: null,
                
                project_id: null,

                // give an url back to the user
                share_url: '',
                createlink_show: true,
                create_share_loading: false,
            }
        },
        props: {
            reviewables : null,
        },
        computed: {
            filteredDataArray_Project() {
                return this.project_names.filter((option) => {
                    return option
                        .toString()
                        .toLowerCase()
                        .indexOf(this.project_autocomplete_name.toLowerCase()) >= 0
                })
            }
        },
        methods: {
            GetProjectID(projectname) {
                this.projects.forEach(project => {
                    
                    if (project.name == projectname){

                        console.info('projectname', projectname)
                        console.info('project.name:', project.name)
                        console.log(project.id)

                        this.project_id = project.id
                    }
                })
            },
            SubmitForm() {
                // POST to API
                this.CreateShare()

                // Close dialog
                // this.$parent.close()
            },
            async copyURL(mytext) {
            try {
                    await navigator.clipboard.writeText(mytext);
                    this.$refs.input_url.focus()
                } catch($e) {
                    alert('Copying to clipboard failed');
                }
            },
            CreateShare() {
                // set button to loading
                this.create_share_loading = true

                // I couldnt get formdata to work with an array (like in UploadForm.vue)
                // payload worked better! No headers, no messing around
                let resturl = window.location.origin + '/api/reviewableshares/'

                // get the logged in user
                this.FillUserDetails()

                // API used to be URLs, not anymore! use ids
                let reviewable_ids = []
                this.reviewables.forEach(rev => {
                    reviewable_ids.push(rev.id)
                    
                });

                // get project id from the name
                // sets this.project_id
                this.GetProjectID(this.project_autocomplete_name)

                console.log(this.project_id)

            
                // create payload instead of formdata
                let payload = {
                    name: this.name,
                    user: this.user,
                    project: this.project_id,
                    reviewables : reviewable_ids
                }

                // POST a new reviewableshare on den-server
                axios.post(resturl,
                    payload,
                    {
                        // headers: {
                        //   'Content-Type': 'multipart/form-data'
                        // }
                    })
                    .then(response => {
                        // create link from UUID from the response
                        this.share_url = window.location.origin + "/share/" + response.data.uuid

                        // hide button
                        this.createlink_show = false
                 
                        //Nodal for copying to clipboard
                        this.copyURL(this.share_url)

                        // focus on input url (switched to v-show, v-if was 'too slow')
                        this.$refs.input_url.focus()

                        // reset create link button
                        this.create_share_loading = false
                        

                    })
                    .catch(error => console.log(error))
            },
            FillUserDetails() {
                if (localStorage.getItem("den_user") === null) {
                    this.$dialog.alert({
                        title: 'Error',
                        message: 'Error because of old login, please log out and in again',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'alert-outline',
                        iconPack: 'mdi'
                    })
                    // Close dialog
                    this.$parent.close()
                    return
                }
                else {
                    this.user = localStorage.getItem("den_user")
                }
            },
            GetProjectFromReviewable() {
                this.project_autocomplete_name = this.reviewables[0].project
            }
        },
        mounted() {
            this.GetProjectNames()

            // init project from first reviewable
            this.GetProjectFromReviewable()

        },

}
</script>


<style scoped>

</style>

